import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import { ImEye } from "react-icons/im";
import { ImEyeBlocked } from "react-icons/im";
import LoginElement from "../auth/left-panel";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { useAuth } from "../../context/AuthContext"; // Import Auth Context


const SignUp = () => {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dobDay, setDobDay] = useState('');
  const [dobMonth, setDobMonth] = useState('');
  const [dobYear, setDobYear] = useState('');
  const [country, setCountry] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate(); // Use useNavigate instead of useHistory
  const { login } = useAuth(); // Use Auth Context

  const handleSignInClick = () => {
    // Navigate to the SignIn component
    navigate('/signin'); // Updated navigation logic
  };

  // Example countries (replace with your actual list)
  const countries = ['South korea', 'United States', 'Canada', 'United Kingdom', 'Australia'];

  const [errors, setErrors] = useState({});

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form fields
    const newErrors = {};

    if (!email || !validateEmail(email)) {
      newErrors.email = 'Please enter a valid email.';
    }

    if (!username) {
      newErrors.username = 'Username is required.';
    }

    if (!firstName) {
      newErrors.firstName = 'First name is required.';
    }

    if (!lastName) {
      newErrors.lastName = 'Last name is required.';
    }

    if (!dobDay || !dobMonth || !dobYear) {
      newErrors.dob = 'Please select a valid date of birth.';
    }

    if (!country) {
      newErrors.country = 'Please select a country.';
    }

    if (!password) {
      newErrors.password = 'Password is required.';
    }

    // Update errors state
    setErrors(newErrors);

    // ✅ Stop submission if there are errors
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    // ✅ No errors, proceed with registration
    console.log('Form submitted:', { email, username, firstName, lastName, dobDay, dobMonth, dobYear, country, password });

    // ✅ Simulate a successful login
    login();

    // ✅ Navigate to home page
    navigate("/");
  };

  return (
    <div className="login">
      <div className="content-section">
        <LoginElement />
      </div>
      <div className="form-section">
        <div className='l-form-element'>
          <h1>Join the Ultimate Fanhub Hub</h1>
          <h3>Create your account</h3>

          <Form onSubmit={handleSubmit}>
            {/* Email Input Group with Validation */}
            <div className="mb-3">
              <Form.Floating>
                <Form.Control
                  id="floatingEmailCustom"
                  type="email"
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={errors.email ? 'is-invalid' : ''}
                />
                <label htmlFor="floatingEmailCustom">Email address</label>
              </Form.Floating>
              {errors.email && <div className="text-danger mt-1">{errors.email}</div>} {/* ✅ Email error message */}
            </div>

            {/* Username Input Group with Validation */}
            <div className="mb-3">
              <Form.Floating>
                <Form.Control
                  id="floatingUsernameCustom"
                  type="text"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className={errors.username ? 'is-invalid' : ''}
                />
                <label htmlFor="floatingUsernameCustom">Username</label>
              </Form.Floating>
              {errors.username && <div className="text-danger mt-1">{errors.username}</div>} {/* ✅ Username error message */}
            </div>

            {/* First Name Input Group with Validation */}
            <div className="row mb-3 gx-2">
              {/* First Name Input Group with Validation */}
              <div className="col-6">
                <Form.Floating>
                  <Form.Control
                    id="floatingFirstNameCustom"
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className={errors.firstName ? 'is-invalid' : ''}
                  />
                  <label htmlFor="floatingFirstNameCustom">First Name</label>
                </Form.Floating>
                {errors.firstName && <div className="text-danger mt-1">{errors.firstName}</div>} {/* ✅ First Name error message */}
              </div>

              {/* Last Name Input Group with Validation */}
              <div className="col-6">
                <Form.Floating>
                  <Form.Control
                    id="floatingLastNameCustom"
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className={errors.lastName ? 'is-invalid' : ''}
                  />
                  <label htmlFor="floatingLastNameCustom">Last Name</label>
                </Form.Floating>
                {errors.lastName && <div className="text-danger mt-1">{errors.lastName}</div>} {/* ✅ Last Name error message */}
              </div>
            </div>

            {/* Date of Birth Select Dropdowns with Validation */}
            <div className="mb-3">
              <div className="d-flex d-flex-time">
                {/* Day Dropdown with Floating Label */}
                <div className="flex-fill me-2">
                  <FloatingLabel controlId="floatingDay" label="Day">
                    <Form.Select
                      aria-label="Day"
                      value={dobDay}
                      onChange={(e) => setDobDay(e.target.value)}
                      className={errors.dob ? 'is-invalid' : ''}
                    >
                      <option value="">Day</option>
                      {[...Array(31)].map((_, i) => (
                        <option key={i} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </div>

                {/* Month Dropdown with Floating Label */}
                <div className="flex-fill me-2">
                  <FloatingLabel controlId="floatingMonth" label="Month">
                    <Form.Select
                      aria-label="Month"
                      value={dobMonth}
                      onChange={(e) => setDobMonth(e.target.value)}
                      className={errors.dob ? 'is-invalid' : ''}
                    >
                      <option value="">Month</option>
                      {[...Array(12)].map((_, i) => (
                        <option key={i} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </div>

                {/* Year Dropdown with Floating Label */}
                <div className="flex-fill">
                  <FloatingLabel controlId="floatingYear" label="Year">
                    <Form.Select
                      aria-label="Year"
                      value={dobYear}
                      onChange={(e) => setDobYear(e.target.value)}
                      className={errors.dob ? 'is-invalid' : ''}
                    >
                      <option value="">Year</option>
                      {[...Array(100)].map((_, i) => (
                        <option key={i} value={2022 - i}>
                          {2022 - i}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </div>
              </div>

              {errors.dob && <div className="text-danger mt-1">{errors.dob}</div>} {/* Date of Birth error message */}
            </div>


            {/* Country Dropdown with Validation */}
            <div className="mb-3">
              <FloatingLabel controlId="floatingSelect" label="Select Country">
                <Form.Select
                  aria-label="Floating label select example"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  className={errors.country ? 'is-invalid' : ''}
                >
                  <option value="">Select Country</option>
                  {countries.map((country, index) => (
                    <option key={index} value={country}>
                      {country}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
              {errors.country && <div className="text-danger mt-1">{errors.country}</div>} {/* ✅ Country error message */}
            </div>

            {/* Password Input Group with Validation */}
            <div className="mb-3 position-relative">
              <Form.Floating>
                <Form.Control
                  id="floatingPasswordCustom"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={errors.password ? 'is-invalid' : ''}
                />
                <label htmlFor="floatingPasswordCustom">Password</label>
              </Form.Floating>
              <Button
                variant="outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
                className="position-absolute top-50 translate-middle-y password-view-btn"
                style={{ border: 'none' }}
              >
                {showPassword ? <ImEyeBlocked /> : <ImEye />}
              </Button>
              {errors.password && <div className="text-danger mt-1">{errors.password}</div>} {/* ✅ Password error message */}
            </div>

            {/* Submit Button */}
            <Button type="submit" className="btn btn-primary w-100 signup-btn">
              Register
            </Button>

            {/* Already have an account? Link */}
            <p className="tarm-Policy">
              By creating an account, you agree to our <Link to={`/help`}>Terms of Use</Link> and <Link to={`/help`}>Privacy Policy</Link>
            </p>
          </Form>
          <div className="signup-btn-element">
            <p>Already have an account?</p>
            <Button variant="outline-primary" className="w-100 mt-3 signup-btn" onClick={handleSignInClick}>
              Sign In
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
